import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { LocalizedStringRecord } from "../../app/slices/TrainingLocalizationSlice";
import {
  InteractionFactoryEntity,
  ReconcileContext,
} from "../../features/interaction_factory/InteractionFactory";
import ShowUIPropPreview from "../../features/previews/show_ui_prop/ShowUIPropPreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import { Prop } from "../Prop";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";

export interface IShowUIProp extends Interaction {
  propGuid: string;
  prefabName: string;
}

export const ShowUIPropInteraction = (): InteractionFactoryEntity => {
  const view = <ShowUIPropPreview />;

  const create = (getKeys: (amount: number) => string[]): IShowUIProp => {
    return {
      id: GetNewGuid(),
      name: "Show UI Prop",
      type: InteractionType.ShowUIProp,
      propGuid: "",
      prefabName: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IShowUIProp => {
    return interaction as IShowUIProp;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): IShowUIProp => {
    return {
      ...(interaction as IShowUIProp),
      id: GetNewGuid(),
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
    take: Take,
    actorPresets: Actor[]
  ): string[] => {
    const converted = interaction as IShowUIProp;
    const warnings: string[] = [];

    return warnings;
  };

  const reconcile = (
    interaction: Interaction,
    context: ReconcileContext
  ): IShowUIProp => {
    const converted = interaction as IShowUIProp;
    const fresh = context.prefabNameByInstanceId[converted.propGuid];
    if (!fresh || fresh === converted.prefabName) return converted;
    context.changes.push({
      scope: "interaction",
      id: converted.id,
      label: converted.name,
      field: "prefabName",
      oldValue: converted.prefabName,
      newValue: fresh,
    });
    return { ...converted, prefabName: fresh };
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as IShowUIProp;
    const searchableStrings: string[] = [
      interaction.name,
      converted.prefabName,
    ];

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType
    );
  };

  const filterType: string = "ShowUIProp";

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[],
    allPropPresets: Prop[],
    localizedStringRecords: LocalizedStringRecord
  ): string[] => {
    const converted = interaction as IShowUIProp;
    const errors: string[] = [];

    if (!converted.propGuid) errors.push("No prop selected");

    return errors;
  };

  return {
    View: view,
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Reconcile: reconcile,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
